import {useMutation} from "@apollo/client";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {
  GQL_INTEGRATION_DELETE,
  GQL_INTEGRATIONS_PAGE_QUERY,
  GQL_INTEGRATIONS_QUERY,
} from "@/lib/queries/integrations.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {IntegrationListData} from "@/lib/types/integrations.ts";

export interface IntegrationActionDeleteProps {
  integration: IntegrationListData;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const IntegrationActionDelete = ({integration, show, setShow}: IntegrationActionDeleteProps) => {
  const [deleteIntegration, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(GQL_INTEGRATION_DELETE, {
    refetchQueries: [GQL_INTEGRATIONS_QUERY, GQL_INTEGRATIONS_PAGE_QUERY],
  });

  const handleSubmit = async () => {
    const response = await deleteIntegration({
      variables: {
        id: integration.id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  return (
    <>
      <DeleteActionDialog
        show={show}
        loading={loading}
        title={serverErrors?.length > 0 ? "Unable to delete Integration" : "Delete Integration"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setShow(false);
          reset();
        }}
      >
        {serverErrors?.length > 0 && serverErrors[0]}
        {!serverErrors?.length && (
          <>
            Are you sure you want to delete Integration <strong>{integration.name}</strong>?
          </>
        )}
      </DeleteActionDialog>
    </>
  );
};
